import React from 'react';
import { CroppedImageView } from '@bingads-webui-campaign-react/cropped-image-view';

import { AppAdsBasePlacement } from './app-ads-base-placement';
import { getAppAdsMSNMobileStyles } from '../../styles/ad-placement-components/app-ads-ad-placement-styles';
import { withUAPLThemedStyles } from '../../with-themed-styles';
import { PlacementDescription, BusinessNameWithAdsLabel } from '../../shared-components';

export const AppAdsMSNDisplayPlacement = withUAPLThemedStyles(
  (props) => {
    const {
      classes,
      placementData, // UAPVMSingleImagePlacement
      businessName,
      description,
      i18n, // may need to set window._TL_ in other platforms
    } = props;

    const {
      placementMeta, placementCropping, imageMeta, effectiveImageUrl, effectiveImageWidth, effectiveImageHeight, expandedPlacementCropping,
    } = placementData || {};
    const { previewHeight, aspectRatio } = placementMeta || {};
    if (!placementData || !imageMeta) {
      return null;
    }

    const cropping = expandedPlacementCropping || placementCropping;

    return (
      <AppAdsBasePlacement
        classes={classes}
      >
        <div className={classes.msnPlacementImage}>
          <CroppedImageView
            resizeImageHeight={previewHeight}
            aspectRatio={aspectRatio}
            src={effectiveImageUrl || imageMeta.url}
            originalWidth={effectiveImageWidth || imageMeta.originalWidth}
            originalHeight={effectiveImageHeight || imageMeta.originalHeight}
            SourceX={cropping && cropping.SourceX}
            SourceY={cropping && cropping.SourceY}
            SourceWidth={cropping && cropping.SourceWidth}
            SourceHeight={cropping && cropping.SourceHeight}
          />
        </div>
        <div className={classes.msnPlacementTextContainer}>
          <PlacementDescription
            description={description}
            i18n={i18n}
            placementDescriptionClassName={classes.msnDescription}
          />
        </div>
        <div className={classes.msnBusinessName}>
          <BusinessNameWithAdsLabel
            showAdsLabel
            businessName={businessName}
            i18n={i18n}
            rootClassName={classes.msnBusinessNameWithAdsLabel}
          />
        </div>
      </AppAdsBasePlacement>
    );
  },
  getAppAdsMSNMobileStyles,
  { componentName: 'AppAdsMSNDisplayPlacement' }
);
